// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"5f1ddcfa","864":"7e70ae4d"}[chunkId] + ".chunk.js";
};